import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DetailedHTMLProps, ButtonHTMLAttributes } from "react";
import { TBootsColor } from "../../../Interfaces/Utils/Style/StyleInterfaces";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface IBigActionButtonProps
    extends DetailedHTMLProps<
        ButtonHTMLAttributes<HTMLButtonElement>,
        HTMLButtonElement
    > {
    icon: IconProp;
    children: React.ReactNode;
    color: TBootsColor;
    tooltip?: string;
}

export default function BigActionButton(props: IBigActionButtonProps) {
    const { icon, children, color, tooltip, ...buttonProps } = props;
    return (
        <span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{tooltip}</Tooltip>}>
                <button
                    type={"button" ?? buttonProps.type}
                    style={{
                        ...buttonProps?.style,
                    }}
                    className={`btn btn-light-${color} btn-sm btn-icon icon-xl ${
                        props.className ?? ""
                    }`}
                    {...buttonProps}
                >
                    <FontAwesomeIcon icon={icon} /> <small>{children}</small>
                </button>
            </OverlayTrigger>
        </span>
    );
}
